import React from 'react';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { useTranslation } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';

export const TerminalFooterSection = observer(() => {
  const { balance, currencySymbolOrCode } = userInfoStore;
  const t = useTranslation();

  return (
    <div className='tb-balance-holder'>
      <p className='tb-balance-holder-txt'>
        {t('BALANCE')}: {balance} {currencySymbolOrCode}
      </p>
      <i className='icon-balance-eye' />
    </div>
  );
});
